/* eslint-disable @typescript-eslint/no-explicit-any */
import { downloadMedia } from '@/adapters/media';
import { IMedia } from '@/interfaces/media';

const mediaDownload = async (media: IMedia) => {
  try {
    const mediaFile = await downloadMedia(media.id);

    // Create a Blob from the response data
    const blob = new Blob([mediaFile.data as any], {
      type: mediaFile.headers['content-type'],
    });

    // Create a URL for the Blob
    const url = window.URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', media.name); // You can set a specific filename here

    // Append the link to the body
    document.body.appendChild(link);

    // Trigger the download
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url); // Clean up the URL object
  } catch (error) {
    console.error('Error downloading the file', error);
  }
};

const mediaView = async (media: Partial<IMedia>) => {
  try {
    const mediaFile = await downloadMedia(Number(media.id));

    // Create a Blob from the response data
    const blob = new Blob([mediaFile.data as any], {
      type: mediaFile.headers['content-type'],
    });

    // Create a URL for the Blob
    const url = window.URL.createObjectURL(blob);

    // Open the Blob URL in a new tab
    window.open(url, '_blank');

    // Clean up the URL object after a delay to ensure the new tab opens
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 100);
  } catch (error) {
    console.error('Error downloading the file', error);
  }
};

const mediaUrlCache = new Map<number, string>();

const mediaUrl = async (media: Partial<IMedia>) => {
  const id = Number(media.id);
  if (mediaUrlCache.has(id)) {
    const cached = mediaUrlCache.get(id);
    if (cached) return cached;
  }

  try {
    const mediaFile = await downloadMedia(id);
    const blob = new Blob([mediaFile.data as any], {
      type: mediaFile.headers['content-type'],
    });
    const url = window.URL.createObjectURL(blob);
    mediaUrlCache.set(id, url);
    return url;
  } catch (error) {
    console.error('Error downloading the file', error);
    return '';
  }
};

export { mediaDownload, mediaView, mediaUrl };
